<template>  
  <div class="orders" :class="dynamicClass">
    <!--<v-touch v-on:swipedown="onSwipe">-->
      <nna-row v-for="order in orders" :key="order.oid" @click.native="goToDetail(order.oid)">  
        <nna-col align="left">   
          <div class="text-color-primary">{{order.shop}}</div>
          <div class="text-align-left">#{{order.number}} - {{order.date}}</div>
        </nna-col>
        <nna-col align="right">
          <div class="muted text-align-left">{{order.status}}</div>
        </nna-col>        
        <nna-col align="right">
          <div class="text-color-primary orders__total">€{{order.total}}</div>
        </nna-col>        
      </nna-row>      
    <!--</v-touch>-->
  </div>  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'OrdersList',
  components: {    
  },
  data() {
    return {
      boolean: false,
      interval: null,
      newOrder: false
    }
  },
  props: {
    tableHead: {
      type: Boolean,
      default: true
    },         
  },
  computed: {
    ...mapGetters({
      orders: 'order/orders'
    }),   
    dynamicClass() {
      return {
        ["updateOrders"]: this.newOrder
      }
    } 
  },
  watch: {
    orders(newVal) {
      this.applyClass()
    }
  },  
  methods: {
    ...mapActions({
      getOrders: 'order/getOrders'
    }),
    onSwipe() {
      this.getOrders()
    },
    goToDetail(oid) {
      this.$router.push({ name: 'order.detail', params: { id: oid } })
    },
    polling() {
      this.interval = setInterval(this.getOrders, 10000)
    },
    applyClass() {
      this.newOrder = true
      setTimeout(() => {
        this.newOrder = false
      }, 2000)
    },
    onCheck(){
      console.log(this.orders)
    }
  },
  async mounted() {
    await this.getOrders()
    //this.polling()
  },
  beforeDestroy() {
    //clearInterval(this.interval)
  }  
}
</script>

<style lang="scss">
.orders__total {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/modules/common/components/list/Orders.vue